import { Job } from '../types';

const firstNonEmptyValue = (...values: Array<string | null | undefined>): string => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return '';
};

export const getJobDirectoryLocation = (job: Job): string => firstNonEmptyValue(job.cust_location, job.address, job.job_location);

export const getJobCardGender = (job: Job): string => {
  const detailGender = Array.isArray(job.job_details) ? job.job_details[0]?.gender : undefined;
  return firstNonEmptyValue(job.job_gender, job.cust_gender, job.sex, detailGender);
};

export const getJobLocation = (job: Job): string => {
  let location = job.address || job.job_location || job.job_detail_location || job.cust_location || job.location || job.add_state || '';
  
  if (job.job_details) {
    try {
      const details = typeof job.job_details === 'string' 
        ? JSON.parse(job.job_details) 
        : job.job_details;
        
      if (Array.isArray(details) && details.length > 0) {
        const d = details[0] as any;
        let loc = d.location || d.address;
        if (!loc && d.add_city && d.add_state) {
            loc = `${d.add_city}, ${d.add_state}`;
        } else if (!loc) {
            loc = d.add_city || d.add_state;
        }
        location = loc || location;
      } else if (details && !Array.isArray(details)) {
        const d = details as any;
        let loc = d.location || d.address;
        if (!loc && d.add_city && d.add_state) {
            loc = `${d.add_city}, ${d.add_state}`;
        } else if (!loc) {
            loc = d.add_city || d.add_state;
        }
        location = loc || location;
      }
    } catch (e) {
      console.warn('Failed to parse job_details for location', e);
    }
  }
  
  return location;
};
